module.exports = __webpack_public_path__ + "static/img/88051C_2_3_R_20181204_fit.b295112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88051C_2_3_R_20181204_fit.png
// module id = 6nT+
// module chunks = 0